'use client';

import React from "react";

export default function TwoColumnLayout({
  left,
  right,
}: {
  left: React.ReactNode;
  right: React.ReactNode;
}) {
  return (
    <div className={`grid grid-cols-1 gap-4 ${right ? "md:grid-cols-3" : ""}`}>
      <div className={right ? "md:col-span-2" : ""}>{left}</div>
      {right && <div className="md:col-span-1">{right}</div>}
    </div>
  );
}

